/**************************************************
 * Nombre:       Tarjeta_Indicador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Grid2, Typography} from "@mui/material";
import {BORDER, SOMBRA} from "../../ContantesColorGraficas";
import {theme} from "../../../Tema";
import icon from '../../RecursosGraficas/icon_default.svg'

const Tarjeta_Indicador = ({color = theme.palette.primary.main, icono=icon, titulo, valor}) => {

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: color + 20,
                borderRadius: 2,
                p: 3,
                height: '100%',
                maxHeight: {xs: 210, sm: 500}
            }}
        >

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 1}} >
                <img src={icono} height={50} width={'auto'} />
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Typography sx={{color: color, fontSize: 14, fontWeight: 700, textAlign: 'center'}} >{titulo}</Typography>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{color: color, fontSize: 18, fontWeight: 700, textAlign: 'center'}} >{valor}</Typography>
            </Grid2>

        </Grid2>
    )

}
export default Tarjeta_Indicador